import React from 'react';
import { Typography } from '@wbk/ui';
import { twMerge } from 'tailwind-merge';

interface HeroTitleProps {
  title: string;
  component?: React.ElementType;
  className?: string;
}

const HeroTitle: React.FC<HeroTitleProps> = ({ title, component = 'h1', className }) => {
  // Parsing logic from ScrollTitle component
  const _title = title.split('-').map((part, index, array) => {
    const coloredText = part.split(/(\d+)/).map((segment, segIndex) => {
      return /^\d+$/.test(segment) ? (
        <span key={segIndex} className='text-blue-500'>
          {segment}
        </span>
      ) : (
        segment
      );
    });

    return (
      <React.Fragment key={index}>
        {coloredText}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    );
  });

  const mergedClasses = twMerge(
    'text-heading-XL sm:text-heading-XXL sm:leading-[58px] md:text-display-S font-bold leading-tighter md:leading-[84px] -tracking-[4px] font-gellix',
    className
  );

  return (
    <Typography as={component} className={mergedClasses}>
      {_title}
    </Typography>
  );
};

export default HeroTitle;
